import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c7cd0c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "DrainageResourceQuery" }
const _hoisted_2 = { style: {"height":"50px","display":"inline-flex","margin":"0 auto"} }
const _hoisted_3 = { style: {"height":"50px","line-height":"50px","text-align":"center","margin-left":"14px"} }
const _hoisted_4 = { class: "itemModal" }
const _hoisted_5 = { style: {"display":"flex","align-items":"center","gap":"10px"} }
const _hoisted_6 = { style: {"height":"50px","display":"inline-flex","margin":"0 auto"} }
const _hoisted_7 = { style: {"height":"50px","line-height":"50px","text-align":"center","margin-left":"14px"} }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {getListData, getPageListData} from "@/service/main/system";
import {useStore} from "@/store";
import {initEmptyParam} from "@/hooks/useInitParam";
import {ref, watch} from "vue";
import {ElInput, ElLoading} from "element-plus";
import {customerTableConfig} from "./config/customer.config";
import LfTable from "@/components/LfTable.vue";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'DrainageResourceQuery',
  setup(__props) {

initEmptyParam()
const store = useStore()

const getChannelList = async () => {
  let channelData = await getListData('/main/customerChannel/queryAllChannel', {})
  const channelItem = searchFormConfig.formItems.find(item => item.field === 'channel')
  channelItem!.options = channelData.map((item: any) => {
    return {title: item, value: item}
  })
}
getChannelList()

const getThirdPartyList = async () => {
  let thirdPartyData = await getListData('/main/customerChannel/queryThirdParty', {})
  const thirdPartyItem = searchFormConfig.formItems.find((item) => item.field === 'third')
  thirdPartyItem!.options = thirdPartyData.map((item: any) => {
    return {title: item, value: item}
  })
}
getThirdPartyList()

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})
  const roleItem = searchFormConfig.formItems.find((item) => item.field === 'corpName')
  roleItem!.options = roleData.map((item: any) => {
    return {title: item.name, value: item.name}
  })
}
getCompanyList()

const queryParam = {
  cfddFlag: false,
  pageNo: 1,
  pageSize: 10
}
store.commit('system/changeQueyryInfo', queryParam)

const resetCb = () => {
  return queryParam
}

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const inputName = ref('');
const inputUnionId = ref('');
const listDialogVisible = ref(false)
const listDialogTitle = ref('')
const listTableTitle = ref('');
const dataList = ref<any[]>([])
const dataCount = ref<number>(0)
const pageInfo = ref({pageNo: 1, pageSize: 10})
const handleDealCustomer = () => {
  listDialogVisible.value = true;
  listDialogTitle.value = '成交客户'
  listTableTitle.value = '客户列表'
  getListPageData();
}

const getListPageData = async () => {
  const condition = {
    pageNo: pageInfo.value.pageNo,
    pageSize: pageInfo.value.pageSize,
    nickName: inputName.value,
    unionId: inputUnionId.value
  }
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '查询数据中...',
    background: 'rgba(0, 0, 0, 0.5)'
  });
  await getPageListData(
    '/main/drainageResourceQuery/getDealCustomers',
    condition,
  ).then((res) => {
    loadingInstance.close()
    dataList.value = res.list
    dataCount.value = Number(res.total)
  })
}

const dialogClose = () => {
  dataList.value = [];
  pageInfo.value.pageNo = 1;
  pageInfo.value.pageSize = 10;
  dataCount.value = 0;
}
watch(pageInfo, () => getListPageData())

const intentUnionId = async (unionId: string) => {
  store.commit('system/changeQueyryInfo', {
    unionId: unionId
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
  inputUnionId.value = ''
  inputName.value = ''
  listDialogVisible.value = false
}

const [pageContentRef, handleResetClick, handleSearchClick, handleDownBtnClick] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "drainageResourceQuery",
      downFilename: "引流资源.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick),
      onDealCustomerClick: handleDealCustomer,
      onSortChange: handleSortChange
    }, {
      consumer: _withCtx((scope) => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_avatar, {
            shape: "square",
            size: 50,
            src: scope.row.avatar
          }, null, 8, ["src"]),
          _createElementVNode("span", _hoisted_3, _toDisplayString(scope.row.uname), 1)
        ])
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick"]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_el_dialog, {
        title: listDialogTitle.value,
        modelValue: listDialogVisible.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((listDialogVisible).value = $event)),
        width: "50%",
        center: "",
        "destroy-on-close": "",
        onClosed: dialogClose
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(ElInput), {
              modelValue: inputName.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputName).value = $event)),
              placeholder: "请输入客户昵称",
              clearable: "",
              style: {"flex":"1"}
            }, null, 8, ["modelValue"]),
            _createVNode(_unref(ElInput), {
              modelValue: inputUnionId.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((inputUnionId).value = $event)),
              placeholder: "请输入客户UnionId",
              clearable: "",
              style: {"flex":"1"}
            }, null, 8, ["modelValue"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: getListPageData
            }, {
              default: _withCtx(() => [
                _createTextVNode("查询")
              ]),
              _: 1
            })
          ]),
          _createVNode(LfTable, _mergeProps({
            listData: dataList.value,
            listCount: dataCount.value,
            title: listTableTitle.value
          }, _unref(customerTableConfig), {
            page: pageInfo.value,
            "onUpdate:page": _cache[2] || (_cache[2] = ($event: any) => ((pageInfo).value = $event))
          }), {
            consumer: _withCtx((scope) => [
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_el_avatar, {
                  shape: "square",
                  size: 50,
                  src: scope.row.avatar
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_7, _toDisplayString(scope.row.uname), 1)
              ])
            ]),
            unionId: _withCtx((scope) => [
              _createVNode(_component_el_link, {
                class: "text-link",
                href: "javascript:;",
                onClick: ($event: any) => (intentUnionId(scope.row.unionId))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(scope.row.unionId), 1)
                ]),
                _: 2
              }, 1032, ["onClick"])
            ]),
            _: 1
          }, 16, ["listData", "listCount", "title", "page"])
        ]),
        _: 1
      }, 8, ["title", "modelValue"])
    ])
  ]))
}
}

})